const accordion = (() => {
    const elements = document.querySelectorAll('[data-accordion]');
    let counter = 0;

    /**
     * @function init
     * @desc init functions & events
     */
    const init = () => {
        // selectorObserver("[data-accordion]", initEvents);
        elements.forEach((el) => initEvents( el ));
    };

    /**
     * @function initEvents
     * @desc
     */
    const initEvents = (element) => {
        const triggers = element.querySelectorAll('[data-item-trigger]');
        let showMore = element.querySelector('[data-more-content]');
        const content = element.querySelector('[data-item-content]');

        //fix with data-more-container for more button outside accordion
        let moreContainer = element.dataset.moreContainer;
        if (!showMore && moreContainer) {
            showMore = document.querySelector(moreContainer).querySelector('[data-more-content]');
        }

        for (let i = 0; i < triggers.length; i++) {
            triggers[i].addEventListener('click', onClickTrigger);
            setAria(triggers[i], i);
        }

        if (showMore)
            showMore.addEventListener('click', (event) => toggleMoreContent(event, element));

        if (content)
            content.addEventListener('transitionend', (event) => onTransitionEnd(event, element));

        counter++;
    };

    /**
     * @function setAria
     * @desc set WCAG
     */
    function setAria(element, tempCounter) {
        let item = element.parentNode;
        let content = item.querySelector("[data-item-content]");
        element.setAttribute( 'aria-expanded', (item.classList).contains("expanded") );
        element.setAttribute( 'id', "accordion-"+counter+"_trigger-"+tempCounter );
        element.setAttribute( 'aria-controls', "accordion-"+counter+"_content-"+tempCounter );
        content.setAttribute( 'aria-labelledby', "accordion-"+counter+"_trigger-"+tempCounter );
        content.setAttribute( 'id', "accordion-"+counter+"_content-"+tempCounter );
    }

    /**
     * @function open
     * @desc manage accordion opening and closing
     */
    const onClickTrigger = (event) => {
        event.preventDefault();
        let element = event.currentTarget;
        let parent = element.parentNode;
        let inner = parent.querySelector(".accordion-inner");
        let content = parent.querySelector("[data-item-content]");
        let status = element.getAttribute('aria-expanded') == 'true';
        const textValue = element.getAttribute('data-toggle-text');

        if (textValue) {
            const more = textValue.split('|')[0] || 'Więcej';
            const less = textValue.split('|')[1] || 'Mniej';
            element.querySelector(".toggle-text").innerText = ((status) ? more : less);
        }

        element.setAttribute('aria-expanded', !status);
        parent.classList.toggle("expanded");

        if(inner) {
            if(status) {
                content.style.height = 0;
            } else {
                content.style.height = inner.offsetHeight+"px";
                content.style.display = "block";
            }
        }
    };

    const onTransitionEnd = (event, element) => {
        if(!element.querySelector("[data-accordion-item]").classList.contains("expanded"))
            element.querySelector("[data-item-content]").style.display = "";
    };

    /**
     * @function handleFaqReveal
     * @ reveal more FAQs when 'more' button clicked
     */

    function toggleMoreContent(event, element) {
        const button = event.currentTarget;
        const buttonText = button.querySelector('[data-toggle-text]');
        const textValue = buttonText.getAttribute('data-toggle-text');
        const hiddenItems = element.querySelectorAll("[data-item-hidden]");

        const more = textValue.split('|')[0] || 'Więcej';
        const less = textValue.split('|')[1] || 'Mniej';

        if (button.classList.contains('is-active')) {
            button.classList.remove('is-active');
            buttonText.innerText = more;
            hiddenItems.forEach((elem) => elem.classList.remove('visible'));
        } else {
            button.classList.add('is-active');
            buttonText.innerText = less;
            hiddenItems.forEach((elem) => elem.classList.add('visible'));
        }
    }

    /**
     * @desc return the object as public
     */
    return {
        init: init
    };

})();

export {accordion};
